var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVault(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5800",
    "data-name": "Group 5800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-2"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#fill-2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_345",
    "data-name": "Rectangle 345",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5594",
    "data-name": "Group 5594",
    transform: "translate(1 1.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5753",
    "data-name": "Group 5753"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2049",
    "data-name": "Rectangle 2049",
    transform: "translate(1.294)",
    fill: "none",
    stroke: "#0070b6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.706,
    height: 20.706,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18.706,
    height: 18.706,
    rx: 4,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2052",
    "data-name": "Rectangle 2052",
    transform: "translate(1.294)",
    fill: "none",
    stroke: "#0070b6",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.706,
    height: 20.706,
    rx: 5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19.706,
    height: 19.706,
    rx: 4.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5754",
    "data-name": "Group 5754",
    transform: "translate(0 3.235)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2053",
    "data-name": "Rectangle 2053",
    fill: "none",
    stroke: "#0070b6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill",
    width: 1.941,
    height: 4.529,
    rx: 0.971,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1.9411765336990356M1,0v4.529411792755127M1.9411765336990356,3.529411792755127h-1.9411765336990356M0.9411765336990356,4.529411792755127v-4.529411792755127",
    fill: "none",
    clipPath: "url(#clip)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_2054",
    "data-name": "Rectangle 2054",
    transform: "translate(0 9.706)",
    fill: "none",
    stroke: "#0070b6",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    id: "fill-2",
    width: 1.941,
    height: 4.529,
    rx: 0.971,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,1h1.9411765336990356M1,0v4.529411792755127M1.9411765336990356,3.529411792755127h-1.9411765336990356M0.9411765336990356,4.529411792755127v-4.529411792755127",
    fill: "none",
    clipPath: "url(#clip-2)"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_8",
    "data-name": "Subtraction 8",
    d: "M.864,9.061a.857.857,0,0,1-.611-.253.865.865,0,0,1,0-1.222l1.3-1.3a3.454,3.454,0,0,1,0-3.513l-1.3-1.3A.864.864,0,0,1,.864,0a.857.857,0,0,1,.611.254l1.3,1.3a3.464,3.464,0,0,1,3.51,0l1.3-1.3A.864.864,0,0,1,8.8,1.477l-1.3,1.3a3.451,3.451,0,0,1,0,3.51l1.3,1.3A.864.864,0,1,1,7.584,8.806l-1.3-1.3a3.46,3.46,0,0,1-3.513,0l-1.3,1.3A.857.857,0,0,1,.864,9.061ZM4.53,2.8A1.728,1.728,0,1,0,6.258,4.53,1.73,1.73,0,0,0,4.53,2.8Z",
    transform: "translate(7.117 5.823)",
    fill: "#0070b6"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVault);
export default __webpack_public_path__ + "static/media/vault.6bab3f35955303bdaecf89923e1e8c95.svg";
export { ForwardRef as ReactComponent };